// import React, { createContext, useState, useEffect } from "react";

// export const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const [isAuthenticated, setIsAuthenticated] = useState(() => {
//     const storedToken = localStorage.getItem("auth_token");
//     return !!storedToken;
//   });
  
//   const [user, setUser] = useState(() => {
//     const storedCustomerId = localStorage.getItem("customer_id");
//     const storedFirstName = localStorage.getItem("first_name");
//     const storedEmail = localStorage.getItem("email");
//     const storedMobile = localStorage.getItem("mobile_number");
    
//     if (storedCustomerId) {
//       return {
//         customer_id: storedCustomerId,
//         first_name: storedFirstName,
//         email: storedEmail,
//         mobile_number: storedMobile,
//       };
//     }
//     return null;
//   });
  
//   const [token, setToken] = useState(() => {
//     return localStorage.getItem("auth_token");
//   });

//   const login = (authToken, customer) => {
//     localStorage.setItem("auth_token", authToken);
//     localStorage.setItem("customer_id", customer.customer_id);
//     localStorage.setItem("first_name", customer.first_name);
//     localStorage.setItem("email", customer.email);
//     localStorage.setItem("mobile_number", customer.mobile_number || "");

//     setToken(authToken);
//     setUser(customer);
//     setIsAuthenticated(true);
//   };

//   const logout = () => {
//     localStorage.removeItem("auth_token");
//     localStorage.removeItem("customer_id");
//     localStorage.removeItem("first_name");
//     localStorage.removeItem("email");
//     localStorage.removeItem("mobile_number");

//     setToken(null);
//     setUser(null);
//     setIsAuthenticated(false);
//   };

//   const getCustomerData = () => {
//     return user || {
//       customer_id: localStorage.getItem("customer_id"),
//       first_name: localStorage.getItem("first_name"),
//       email: localStorage.getItem("email"),
//       mobile_number: localStorage.getItem("mobile_number"),
//     };
//   };

//   return (
//     <AuthContext.Provider value={{ 
//       isAuthenticated, 
//       isLoggedIn: isAuthenticated,
//       user, 
//       token, 
//       login, 
//       logout,
//       getCustomerData 
//     }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export default AuthProvider;


import React, { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();


export const AuthProvider = ({ children }) => {
  /* ================= AUTH STATE ================= */

  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return !!localStorage.getItem("auth_token");
  });

  const [user, setUser] = useState(() => {
    const customer_id = localStorage.getItem("customer_id");
    if (!customer_id) return null;

    return {
      customer_id,
      first_name: localStorage.getItem("first_name"),
      email: localStorage.getItem("email"),
      mobile_number: localStorage.getItem("mobile_number"),
    };
  });

  const [token, setToken] = useState(() => {
    return localStorage.getItem("auth_token");
  });

  /* ================= CART COUNT STATE ================= */

  const [cartCount, setCartCount] = useState(() => {
    const storedCount = localStorage.getItem("cart_count");
    return storedCount ? parseInt(storedCount, 10) : 0;
  });

  /* Sync cartCount with localStorage */
  useEffect(() => {
    localStorage.setItem("cart_count", cartCount);
  }, [cartCount]);

  /* ================= LOGIN ================= */

  const login = (authToken, customer) => {
    localStorage.setItem("auth_token", authToken);
    localStorage.setItem("customer_id", customer.customer_id);
    localStorage.setItem("first_name", customer.first_name);
    localStorage.setItem("email", customer.email);
    localStorage.setItem("mobile_number", customer.mobile_number || "");

    setToken(authToken);
    setUser(customer);
    setIsAuthenticated(true);
  };

  /* ================= LOGOUT ================= */

  const logout = () => {
    localStorage.clear();
    setToken(null);
    setUser(null);
    setIsAuthenticated(false);
    setCartCount(0); // Reset cart count on logout
  };

  /* ================= GET CUSTOMER ================= */

  const getCustomerData = () => {
    return user;
  };

  /* ================= UPDATE USER ================= */

  const updateUser = (updatedFields) => {
    setUser((prev) => {
      if (!prev) return prev;

      const updatedUser = { ...prev, ...updatedFields };

      Object.entries(updatedFields).forEach(([key, value]) => {
        localStorage.setItem(key, value ?? "");
      });

      return updatedUser;
    });
  };

  /* ================= PROVIDER ================= */

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        isLoggedIn: isAuthenticated,
        user,
        token,
        login,
        logout,
        getCustomerData,
        updateUser,

        /*  NEW CART GLOBAL STATE */
        cartCount,
        setCartCount,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
